import React from 'react'
import { EventForm } from '@/components/molecules/EventForm/EventForm'
import { EventAnnouncer } from '@/components/organisms/EventAnnouncer/EventAnnouncer'
import { EventSectionCenterProps } from './types'

export function EventSectionCenter({ event, form, background_image, id }: EventSectionCenterProps) {
  const eventData = event.length && event[0]
  const formData = form.length && form[0]

  return (
    <section
      className="p-24 netbook:py-64  netbook:px-90 bg-no-repeat bg-clip-padding bg-center-top"
      style={{ backgroundImage: `url(${background_image.image})` }}
      id={id}
    >
      {eventData && <EventAnnouncer {...eventData} />}
      <div className="max-w-44 mx-auto">{formData && <EventForm {...formData} />}</div>
    </section>
  )
}
